import { tiendasApi } from '../api'

export const workshopsUploadVideoApiSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        getSignedUrl: builder.mutation({
            query: ({ idObjeto, body }) => ({
                url: `workshops/${idObjeto}/get-signed-url`,
                method: 'POST',
                body: body
            })
        }),
        registrarArchivo: builder.mutation({
            query: ({ idObjeto, body }) => ({
                url: `workshops/${idObjeto}/register-imagen`,
                method: 'PUT',
                body: body
            })
        }),
        verUrlProtegida: builder.mutation({
            query: ({ body }) => ({
                url: `workshops/ver-archivo`,
                method: 'POST',
                body: body
            })
        }),
    })
})

export const {
    useGetSignedUrlMutation,
    useRegistrarArchivoMutation,
    useVerUrlProtegidaMutation
} = workshopsUploadVideoApiSlice